import { Swiper, Navigation, Pagination } from 'swiper';

export default class ProductRecommendations {
    constructor() {
        this.init();

        // For shopify customizer/editor
        document.addEventListener("shopify:section:load", function(event) {
            if (event.detail.sectionId === "product-recommendations") {
                this.init();
            }
        });
    }
    
    init() {
        const productRecommendationsSection = document.querySelectorAll('.product-section-recommendations__inner');
        productRecommendationsSection.forEach(section => {
            let productId = section.dataset.productId;
            let limit = section.dataset.limit;
            let min = section.dataset.minrecommendations;
            fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productId+"&limit="+limit+"&section_id=product-recommendations&intent=related")
            .then(response => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;

                if (html.querySelectorAll('.swiper-slide').length > min) {
                    const recommendations = html.querySelector('.swiper');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        const recommendedPlaceholders = section.querySelectorAll('.swiper');
                        recommendedPlaceholders.innerHTML = recommendations.innerHTML;
                        this.initSwiper();
                    }
                } else {
                    this.initSwiper();
                }
            });
        });
    }

    initSwiper() {
        Swiper.use(Navigation, Pagination);
        const recommendedProductCarousel = document.querySelectorAll('.product-section-recommendations .swiper').forEach(carousel => {
            const swiper = new Swiper(carousel, {
                direction: 'horizontal',
                slidesPerView: 'auto',
                spaceBetween: 30,
                navigation: {
                    nextEl: '.product-section-recommendations .swiper-button-next',
                    prevEl: '.product-section-recommendations .swiper-button-prev',
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                    1192: {
                        slidesPerView: 3,
                        spaceBetween: 80
                    },
                    1600: {
                        slidesPerView: 3,
                        spaceBetween: 120
                    }
                }
            });
        })
    }
}